<div class="modal" *ngIf="memberToDetach && group">
    <div class="header">
        <h1 class="title" translate [translateParams]="{ email: memberToDetach.username, group: group.name }">
            PREMIUM_ADMIN_MEMBER_MODAL_DETACH_MEMBER_FROM_GROUP_QUESTION</h1>
    </div>
    <div class="body">
        <ng-container *ngIf="(detachGroupProcessing$ | async); else notDetaching">
            <div class="loading-container">
                <div class="loading-spinner-grey"></div>
            </div>
        </ng-container>
        <ng-template #notDetaching>
            <div class="description" translate [translateParams]="{ email: memberToDetach.username, group: group.name }">
                PREMIUM_ADMIN_MEMBER_MODAL_DETACH_MEMBER_FROM_GROUP_DESCRIPTION
            </div>
            <div class="description">
                {{'PREMIUM_ADMIN_MEMBER_MODAL_DETACH_MEMBER_FROM_GROUP_QUESTION_CONFIRMATION' | translate}}
            </div>
        </ng-template>
    </div>
    <div class="footer">
        <button class="btn-new white" type="submit" (click)="closeModal()" [disabled]="(detachGroupProcessing$ | async)"
            translate>PREMIUM_ADMIN_MEMBER_MODAL_DELETE_MEMBER_BUTTON_LABEL_CANCEL</button>
        <button class="btn-new red" (click)="detachMemberFromGroup()" [disabled]="(detachGroupProcessing$ | async)"
            translate>PREMIUM_ADMIN_MEMBER_MODAL_BUTTON_LABEL_DETACH_MEMBER_FROM_GROUP</button>
    </div>
</div>